(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("learningPathVersionVisibility", {
        templateUrl: "app/learningPaths/version/visibility/learningPathVersionVisibility.component.html",
        controller: ["learningPathVersionVisibilityResource", "messageService", "frameworkService", "DTOptionsBuilder", "$state", "$stateParams", "$translate", LearningPathVersionVisibilityCtrl],
        controllerAs: "vm"
    });
    function LearningPathVersionVisibilityCtrl(learningPathVersionVisibilityResource, messageService, frameworkService, DTOptionsBuilder, $state, $stateParams, $translate) {
        var vm = this;
        vm.number = $stateParams.number;
        vm.version = $stateParams.version;
        vm.loading = true;
        vm.frameworkData = frameworkService.data;
        vm.statuses = [
            { "id": 0, "status": "Disabled" },
            { "id": 1, "status": "Assigned" },
            { "id": 2, "status": "Activated" },
            { "id": 3, "status": "Completed" },
            { "id": 4, "status": "Expired" },
            { "id": 5, "status": "Redo" },
            { "id": 6, "status": "AccessExpired" }
        ];
        vm.logs = [];
        vm.$onInit = init;
        vm.save = save;
        vm.toggleHistory = toggleHistory;
        ///////////////////////////////////////////////////////////
        function init() {
            learningPathVersionVisibilityResource.get({ number: vm.number, version: vm.version }, function (data) {
                vm.model = data;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("order", [0, "desc"])
                .withPaginationType("full_numbers")
                .withDOM("lftip")
                .withBootstrap();
        }
        function save() {
            if (vm.saving)
                return;
            if (vm.model.visibility === 2 && !(vm.model.status.length > 0))
                return;
            vm.saving = true;
            learningPathVersionVisibilityResource.save({ number: vm.number, version: vm.version }, vm.model, function () {
                $state.go("main.learningItems.learningPathVersion", { number: vm.number, version: vm.version });
                vm.saving = false;
                messageService.success("common.changesSaved");
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        }
        function toggleHistory() {
            vm.historyOpen = !vm.historyOpen;
            if (vm.historyOpen && vm.logs.length === 0)
                loadLogs();
        }
        function loadLogs() {
            learningPathVersionVisibilityResource.getLogs({ number: vm.number, version: vm.version }, function (data) {
                vm.logs = data.logs;
            });
        }
    }
}());
